import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../store/gameStore';
import { CurrentUserBet } from './currentUserBet';
import { winningAmountStore } from '../../store/winningAmountStore';
import { ROUND_PHASE_OBJECT_KEYS, ROUND_PHASE_TYPES_NAMES } from '../../enums/betTypesEnum';

export const UserBets = observer(() => {
  const { roundBetsByPhase } = gameStore;
  const { winningAmount } = winningAmountStore;
  const [isShowMyBets, setIsShowMyBets] = useState(false);
  const t = useTranslation();

  const allBetsCount = useMemo(() => {
    if (roundBetsByPhase) {
      return Object.keys(roundBetsByPhase).reduce((acc, cur) => {
        acc += roundBetsByPhase[cur]?.length || 0;
        return acc;
      }, 0);
    }
    return null;
  }, [roundBetsByPhase]);

  useEffect(() => {
    if (winningAmount !== null) {
      setIsShowMyBets(false);
    }
  }, [winningAmount, setIsShowMyBets]);

  return (
    <div className='my-bets-wrapper'>
      <div className='my-bet-section-btn-wrp'>
        <div className='my-bets-section'>
          <div className='my-bet-btn' onClick={() => setIsShowMyBets((prev) => !prev)}>
            <span>{t('MY_BETS')}</span>
            {allBetsCount && <i>{allBetsCount}</i>}
          </div>
          {isShowMyBets && (
            <div className='my-bets-view'>
              <div className='my-bets-title'>
                <span>{t('MY_BETS')}</span>
                <i className='icon-close' onClick={() => setIsShowMyBets(false)} />
              </div>
              <div className='bets-info-m'>
                <div className='scroll-holder'>
                  <div className='scrollable-container'>
                    <div className='my-bets-line'>
                      {Object.keys(ROUND_PHASE_TYPES_NAMES).map((item) => {
                        return (
                          <CurrentUserBet
                            key={item}
                            phaseName={item}
                            betData={
                              roundBetsByPhase?.[
                                ROUND_PHASE_OBJECT_KEYS[ROUND_PHASE_TYPES_NAMES[item]]
                              ]
                            }
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
